import styled, { css } from "styled-components";
import {
  TituloH1 as TituloPrincipal,
  Descricao,
} from "../../../../components/TituloSorriso/styles";
import { colorBrandPrimary } from "../../../../global.style";
import { media } from "../../../../layouts/utils";
import { isMacOs, isIOS } from "react-device-detect";
import { Button } from "veloe-ds";

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: ${colorBrandPrimary.turquoise};
  padding: 2rem 0;

  ${media.desktop`
    height: fit-content;
  `}
`;

export const Container = styled.div`
  display: flex;
  width: 80%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0rem 0;

  ${media.desktop`
    display: block;
    width: 100%;
    padding: 5px;
    margin: 0;
    text-align: center;
  `}
`;

export const TextWrap = styled.div`
  padding: 20px;
  ${media.desktop`
    padding: 0 30px;
  `}
`;

export const Title = styled(TituloPrincipal)`
  ${media.desktop`
    text-align: center;
    max-width: 100%;
    line-height: 28px;
    margin-bottom: 24px;
  `}

  color: ${(props) => props.color};
  padding: 0;
  text-align: left;
  max-width: 300px;
  margin-bottom: 10px;
  line-height: 45px;
  font-weight: 600;
`;

export const Text = styled(Descricao)`
  color: ${(props) => props.color};
  padding: 0;
  text-align: left;
  max-width: 400px;
  font-weight: 500;

  ${media.desktop`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    text-align: center;
  `}
`;

export const Image = styled.img`
  ${media.desktop`
    text-align: left;
    width: 90%;
    height: 100%;
    margin-top: 15px;
  `}
  height: 140px;

  ${media.desktop`
    display: none;
  `}
`;

export const Link = styled.a`
  text-decoration: none;
`;

export const ContainerCTA = styled.div`
  ${media.desktop`
    display: block;
    button {
      width: 100%;
    }
  `}
  display: inline;

  ${media.phone`
    margin-bottom: 20px;
  `}
`;

export const CustomButton = styled(Button)`
  font-family: "Work Sans" !important;
  font-weight: 700;
  margin-top: 1.5rem;
  ${({ disabled }) =>
    disabled
      ? css`
          cursor: not-allowed !important;
          opacity: 0.6 !important;
          color: ${({ color }) => color} !important;
          background: ${({ backgroundColor }) => backgroundColor} !important;
        `
      : css`
          cursor: pointer;
          color: ${({ color }) => color} !important;
          background: ${({ backgroundColor }) => backgroundColor} !important;
        `};

  .label {
    ${(isIOS || isMacOs) &&
      `
      top: 0;
    `}
  }
  ${media.desktop`
    width: 134px !important;
`}
`;
